unit UTagKzModel;

interface

uses
  Js;

type
  TTagKzModel = class
  private
    FVerarbeitet: Boolean;
    FFarbe: Integer;
    FKurzBez: string;
    FBezeichnung: string;
    FDatum: TDateTime;
    FGenehmigt: Boolean;
    procedure ClearValues;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetBezeichnung(const Value: string);
    procedure SetDatum(const Value: TDateTime);
    procedure SetFarbe(const Value: Integer);
    procedure SetGenehmigt(const Value: Boolean);
    procedure SetKurzBez(const Value: string);
    procedure SetVerarbeitet(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    property Datum: TDateTime read FDatum write SetDatum;
    property KurzBez: string read FKurzBez write SetKurzBez;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property Verarbeitet: Boolean read FVerarbeitet write SetVerarbeitet;
    property Genehmigt: Boolean read FGenehmigt write SetGenehmigt;
    property Farbe: Integer read FFarbe write SetFarbe;
  end;

implementation

uses
  System.SysUtils, UEssentialHelper;

{ TTagKzModel }

procedure TTagKzModel.ClearValues;
begin
  Self.Datum := 0;
  Self.KurzBez := '';
  Self.Bezeichnung := '';
  Self.Verarbeitet := true;
  Self.Genehmigt := true;
  Self.Farbe := $FFFFFF;
end;

constructor TTagKzModel.Create;
begin
  Self.ClearValues;
end;

constructor TTagKzModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure TTagKzModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TTagKzModel.SetDatum(const Value: TDateTime);
begin
  FDatum := Value;
end;

procedure TTagKzModel.SetFarbe(const Value: Integer);
begin
  FFarbe := Value;
end;

procedure TTagKzModel.SetGenehmigt(const Value: Boolean);
begin
  FGenehmigt := Value;
end;

procedure TTagKzModel.SetKurzBez(const Value: string);
begin
  FKurzBez := Value;
end;

procedure TTagKzModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Datum'] <> nil then
    Self.Datum := StrToDateTime(string(Obj['Datum']));
  if Obj['KurzBez'] <> nil then
    Self.KurzBez := string(Obj['KurzBez']);
  if Obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(Obj['Bezeichnung']);
  if Obj['Verarbeitet'] <> nil then
    Self.Verarbeitet := StrToBoolean(string(Obj['Verarbeitet']));
  if Obj['Genehmigt'] <> nil then
    Self.Genehmigt := StrToBoolean(string(Obj['Genehmigt']));
  if Obj['Farbe'] <> nil then
    Self.Farbe := StrToInt(string(Obj['Farbe']));
end;

procedure TTagKzModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

procedure TTagKzModel.SetVerarbeitet(const Value: Boolean);
begin
  FVerarbeitet := Value;
end;

end.
